import { Link, LinkProps, useLocation } from 'react-router-dom'

import { cn } from '@/lib/utils'

interface CollapsibleItemProps extends LinkProps {
  isActive?: boolean
}

export function CollapsibleItem({
  className,
  to,
  isActive,
  ...props
}: CollapsibleItemProps) {
  const { pathname } = useLocation()

  if (isActive === undefined) {
    isActive = pathname === to
  }

  return (
    <Link
      to={to}
      className={cn(
        'pl-4 w-full text-nowrap pr-2 h-10 flex justify-between rounded-md items-center text-white hover:bg-white/10',
        isActive && 'bg-white/10',
        className,
      )}
      {...props}
    />
  )
}
